// Text to show for a failed request: the server's own copy when it sent one
// (`message` or `error`), otherwise a plain fallback. Axios's raw
// "Request failed with status code 404" is never shown to an operator.
export const apiErrorMessage = (err, fallback = 'Something went wrong. Please try again.') =>
  err?.response?.data?.message ||
  err?.response?.data?.error ||
  (err?.response ? fallback : err?.message || fallback)

export default apiErrorMessage
